
/**
 * Intended to assist in the filtering of JS bugsnag errors in future
 */
export class IVTError extends Error {}



// WEBPACK FOOTER //
// ./src/lib/error-types.ts